import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../../_common/application/ts/Glob';
import PivotGrid, { FieldChooser } from 'devextreme-react/pivot-grid';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';

class PivotPreview extends React.Component<
    {
        glob: IGlob;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    render() {
        const sales = [
            {
                id: 48,
                region: 'North America',
                country: 'USA',
                city: 'New York',
                amount: 1740,
                date: '2013/03/04'
            },
            {
                id: 49,
                region: 'North America',
                country: 'USA',
                city: 'Los Angeles',
                amount: 3575,
                date: '2013/03/20'
            },
            {
                id: 50,
                region: 'North America',
                country: 'USA',
                city: 'Denver',
                amount: 4500,
                date: '2013/03/04'
            },
            {
                id: 51,
                region: 'North America',
                country: 'CAN',
                city: 'Vancouver',
                amount: 1605,
                date: '2013/03/17'
            },
            {
                id: 52,
                region: 'North America',
                country: 'CAN',
                city: 'Edmonton',
                amount: 800,
                date: '2013/03/21'
            },
            {
                id: 53,
                region: 'South America',
                country: 'BRA',
                city: 'Rio de Janeiro',
                amount: 640,
                date: '2013/03/08'
            },
            {
                id: 54,
                region: 'South America',
                country: 'ARG',
                city: 'Buenos Aires',
                amount: 735,
                date: '2013/03/19'
            },
            {
                id: 55,
                region: 'South America',
                country: 'PRY',
                city: 'Asuncion',
                amount: 2520,
                date: '2013/03/20'
            },
            {
                id: 56,
                region: 'Europe',
                country: 'GBR',
                city: 'London',
                amount: 6675,
                date: '2013/03/18'
            },
            {
                id: 57,
                region: 'Europe',
                country: 'DEU',
                city: 'Berlin',
                amount: 3625,
                date: '2013/03/25'
            },
            {
                id: 58,
                region: 'Europe',
                country: 'ESP',
                city: 'Madrid',
                amount: 1200,
                date: '2013/03/07'
            },
            {
                id: 59,
                region: 'Europe',
                country: 'RUS',
                city: 'Moscow',
                amount: 2000,
                date: '2013/03/07'
            },
            {
                id: 60,
                region: 'Asia',
                country: 'CHN',
                city: 'Beijing',
                amount: 1410,
                date: '2013/03/10'
            },
            {
                id: 61,
                region: 'Asia',
                country: 'JPN',
                city: 'Tokyo',
                amount: 2700,
                date: '2013/03/19'
            },
            {
                id: 62,
                region: 'Asia',
                country: 'KOR',
                city: 'Seoul',
                amount: 5950,
                date: '2013/03/24'
            },
            {
                id: 63,
                region: 'Australia',
                country: 'AUS',
                city: 'Sydney',
                amount: 5120,
                date: '2013/03/08'
            },
            {
                id: 64,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 1980,
                date: '2013/03/17'
            },
            {
                id: 65,
                region: 'Africa',
                country: 'ZAF',
                city: 'Pretoria',
                amount: 1110,
                date: '2013/03/08'
            },
            {
                id: 66,
                region: 'Africa',
                country: 'EGY',
                city: 'Cairo',
                amount: 980,
                date: '2013/03/21'
            },
            {
                id: 67,
                region: 'Australia',
                country: 'AUS',
                city: 'Sydney',
                amount: 5460,
                date: '2013/03/19'
            },
            {
                id: 68,
                region: 'Europe',
                country: 'DEU',
                city: 'Berlin',
                amount: 3800,
                date: '2013/03/12'
            },
            {
                id: 69,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 2610,
                date: '2013/03/04'
            },
            {
                id: 70,
                region: 'Europe',
                country: 'RUS',
                city: 'Moscow',
                amount: 3080,
                date: '2013/03/22'
            },
            {
                id: 71,
                region: 'Asia',
                country: 'JPN',
                city: 'Tokyo',
                amount: 2010,
                date: '2013/03/23'
            },
            {
                id: 72,
                region: 'Asia',
                country: 'CHN',
                city: 'Beijing',
                amount: 1200,
                date: '2013/03/04'
            },
            {
                id: 110,
                region: 'Asia',
                country: 'JPN',
                city: 'Tokyo',
                amount: 9210,
                date: '2013/05/22'
            },
            {
                id: 111,
                region: 'Asia',
                country: 'KOR',
                city: 'Seoul',
                amount: 7950,
                date: '2013/05/12'
            },
            {
                id: 112,
                region: 'Australia',
                country: 'AUS',
                city: 'Sydney',
                amount: 3740,
                date: '2013/05/24'
            },
            {
                id: 113,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 990,
                date: '2013/05/02'
            },
            {
                id: 122,
                region: 'South America',
                country: 'ARG',
                city: 'Buenos Aires',
                amount: 2355,
                date: '2013/06/10'
            },
            {
                id: 123,
                region: 'South America',
                country: 'PRY',
                city: 'Asuncion',
                amount: 1960,
                date: '2013/06/23'
            },
            {
                id: 146,
                region: 'South America',
                country: 'ARG',
                city: 'Buenos Aires',
                amount: 4575,
                date: '2013/07/21'
            },
            {
                id: 147,
                region: 'South America',
                country: 'PRY',
                city: 'Asuncion',
                amount: 2310,
                date: '2013/07/18'
            },
            {
                id: 165,
                region: 'South America',
                country: 'BRA',
                city: 'Rio de Janeiro',
                amount: 2300,
                date: '2013/08/09'
            },
            {
                id: 166,
                region: 'South America',
                country: 'ARG',
                city: 'Buenos Aires',
                amount: 2895,
                date: '2013/08/15'
            },
            {
                id: 185,
                region: 'North America',
                country: 'USA',
                city: 'New York',
                amount: 4410,
                date: '2013/09/12'
            },
            {
                id: 186,
                region: 'North America',
                country: 'USA',
                city: 'Los Angeles',
                amount: 1725,
                date: '2013/09/07'
            },
            {
                id: 187,
                region: 'North America',
                country: 'USA',
                city: 'Denver',
                amount: 2715,
                date: '2013/09/14'
            },
            {
                id: 195,
                region: 'Europe',
                country: 'ESP',
                city: 'Madrid',
                amount: 1020,
                date: '2013/09/04'
            },
            {
                id: 196,
                region: 'Europe',
                country: 'RUS',
                city: 'Moscow',
                amount: 4320,
                date: '2013/09/25'
            },
            {
                id: 197,
                region: 'Asia',
                country: 'CHN',
                city: 'Beijing',
                amount: 7530,
                date: '2013/09/13'
            },
            {
                id: 198,
                region: 'Asia',
                country: 'JPN',
                city: 'Tokyo',
                amount: 2820,
                date: '2013/09/08'
            },
            {
                id: 199,
                region: 'Asia',
                country: 'KOR',
                city: 'Seoul',
                amount: 3050,
                date: '2013/09/04'
            },
            {
                id: 222,
                region: 'Africa',
                country: 'ZAF',
                city: 'Pretoria',
                amount: 1470,
                date: '2013/10/01'
            },
            {
                id: 223,
                region: 'Africa',
                country: 'EGY',
                city: 'Cairo',
                amount: 1810,
                date: '2013/10/02'
            },
            {
                id: 224,
                region: 'North America',
                country: 'USA',
                city: 'New York',
                amount: 600,
                date: '2013/10/23'
            },
            {
                id: 225,
                region: 'North America',
                country: 'USA',
                city: 'New York',
                amount: 7500,
                date: '2013/11/03'
            },
            {
                id: 241,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 2280,
                date: '2013/11/13'
            },
            {
                id: 242,
                region: 'Africa',
                country: 'ZAF',
                city: 'Pretoria',
                amount: 590,
                date: '2013/11/11'
            },
            {
                id: 243,
                region: 'Africa',
                country: 'EGY',
                city: 'Cairo',
                amount: 810,
                date: '2013/11/12'
            },
            {
                id: 259,
                region: 'Asia',
                country: 'KOR',
                city: 'Seoul',
                amount: 625,
                date: '2013/12/22'
            },
            {
                id: 260,
                region: 'Australia',
                country: 'AUS',
                city: 'Sydney',
                amount: 4460,
                date: '2013/12/12'
            },
            {
                id: 261,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 3825,
                date: '2013/12/13'
            },
            {
                id: 326,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 1980,
                date: '2014/03/05'
            },
            {
                id: 327,
                region: 'Africa',
                country: 'ZAF',
                city: 'Pretoria',
                amount: 1820,
                date: '2014/03/07'
            },
            {
                id: 328,
                region: 'Africa',
                country: 'EGY',
                city: 'Cairo',
                amount: 1670,
                date: '2014/03/21'
            },
            {
                id: 359,
                region: 'North America',
                country: 'CAN',
                city: 'Edmonton',
                amount: 1330,
                date: '2014/05/08'
            },
            {
                id: 360,
                region: 'South America',
                country: 'BRA',
                city: 'Rio de Janeiro',
                amount: 1720,
                date: '2014/05/20'
            },
            {
                id: 361,
                region: 'South America',
                country: 'ARG',
                city: 'Buenos Aires',
                amount: 3750,
                date: '2014/05/16'
            },
            {
                id: 384,
                region: 'Europe',
                country: 'DEU',
                city: 'Berlin',
                amount: 5025,
                date: '2014/06/26'
            },
            {
                id: 385,
                region: 'Europe',
                country: 'ESP',
                city: 'Madrid',
                amount: 2400,
                date: '2014/06/08'
            },
            {
                id: 386,
                region: 'Europe',
                country: 'RUS',
                city: 'Moscow',
                amount: 1720,
                date: '2014/06/09'
            },
            {
                id: 409,
                region: 'Asia',
                country: 'CHN',
                city: 'Beijing',
                amount: 1200,
                date: '2014/07/21'
            },
            {
                id: 410,
                region: 'Asia',
                country: 'JPN',
                city: 'Tokyo',
                amount: 5700,
                date: '2014/07/18'
            },
            {
                id: 411,
                region: 'Asia',
                country: 'KOR',
                city: 'Seoul',
                amount: 5575,
                date: '2014/07/01'
            },
            {
                id: 412,
                region: 'Australia',
                country: 'AUS',
                city: 'Sydney',
                amount: 2160,
                date: '2014/07/02'
            },
            {
                id: 435,
                region: 'Asia',
                country: 'KOR',
                city: 'Seoul',
                amount: 7575,
                date: '2014/08/20'
            },
            {
                id: 436,
                region: 'Australia',
                country: 'AUS',
                city: 'Sydney',
                amount: 700,
                date: '2014/08/25'
            },
            {
                id: 437,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 2400,
                date: '2014/08/16'
            },
            {
                id: 467,
                region: 'North America',
                country: 'CAN',
                city: 'Edmonton',
                amount: 2920,
                date: '2014/10/23'
            },
            {
                id: 468,
                region: 'South America',
                country: 'BRA',
                city: 'Rio de Janeiro',
                amount: 3520,
                date: '2014/10/11'
            },
            {
                id: 469,
                region: 'South America',
                country: 'ARG',
                city: 'Buenos Aires',
                amount: 4035,
                date: '2014/10/20'
            },
            {
                id: 470,
                region: 'South America',
                country: 'PRY',
                city: 'Asuncion',
                amount: 1730,
                date: '2014/10/05'
            },
            {
                id: 507,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 1650,
                date: '2014/11/02'
            },
            {
                id: 508,
                region: 'North America',
                country: 'USA',
                city: 'New York',
                amount: 5280,
                date: '2014/12/04'
            },
            {
                id: 509,
                region: 'North America',
                country: 'USA',
                city: 'Los Angeles',
                amount: 3075,
                date: '2014/12/02'
            },
            {
                id: 510,
                region: 'North America',
                country: 'USA',
                city: 'Denver',
                amount: 690,
                date: '2014/12/07'
            },
            {
                id: 612,
                region: 'Australia',
                country: 'AUS',
                city: 'Sydney',
                amount: 4380,
                date: '2015/04/05'
            },
            {
                id: 613,
                region: 'Australia',
                country: 'AUS',
                city: 'Melbourne',
                amount: 4725,
                date: '2015/04/06'
            },
            {
                id: 614,
                region: 'Africa',
                country: 'ZAF',
                city: 'Pretoria',
                amount: 930,
                date: '2015/04/25'
            },
            {
                id: 639,
                region: 'Africa',
                country: 'ZAF',
                city: 'Pretoria',
                amount: 1740,
                date: '2015/05/21'
            },
            {
                id: 640,
                region: 'Africa',
                country: 'EGY',
                city: 'Cairo',
                amount: 500,
                date: '2015/05/26'
            },
            {
                id: 641,
                region: 'South America',
                country: 'ARG',
                city: 'Buenos Aires',
                amount: 780,
                date: '2015/05/07'
            }
        ];

        const dataSource = new PivotGridDataSource({
            fields: [
                {
                    caption: 'Region',
                    width: 120,
                    dataField: 'region',
                    area: 'row',
                    sortBySummaryField: 'Total'
                },
                {
                    caption: 'City',
                    dataField: 'city',
                    width: 150,
                    area: 'row'
                },
                {
                    dataField: 'date',
                    dataType: 'date',
                    area: 'column'
                },
                {
                    groupName: 'date',
                    groupInterval: 'month',
                    visible: false
                },
                {
                    caption: 'Total',
                    dataField: 'amount',
                    dataType: 'number',
                    summaryType: 'sum',
                    format: 'currency',
                    area: 'data'
                }
            ],
            store: sales
        });

        return (
            <div id="pivotContainer">
                <PivotGrid
                    allowExpandAll={true}
                    allowSortingBySummary={true}
                    allowSorting={true}
                    allowFiltering={true}
                    showBorders={true}
                    dataSource={dataSource}
                >
                    <FieldChooser enabled={false} />
                </PivotGrid>
            </div>
        );
    }
}

export function ThemePreview(glob: IGlob, theme) {
    var titlePre = 'Pivot Widget';

    return [
        <div key="widget" className="widget">
            <div className="widget-inner-container">
                <div className="widget-control-panel">
                    <span>{titlePre}</span>
                    <span className="glyphicon glyphicon-remove remove-button header-button"></span>
                    <span className="glyphicon glyphicon-cog config-button header-button"></span>
                    <span className="glyphicon glyphicon-chevron-down menu-button header-button"></span>
                </div>
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-pivot">
                        <PivotPreview
                            //theme={ theme }
                            glob={glob}
                        />
                    </div>
                </div>
            </div>
        </div>
    ];
}
